import { IQuote } from '../quotes';
import { ActionTypes } from './types';

export interface ISetSelectedQuote {
  type: ActionTypes.SetSelectedQuote;
  payload: {
    selectedQuote: IQuote;
  };
}

export interface ISetPurchasedPolicyDetails {
  type: ActionTypes.SetPurchasedPolicyDetails;
  payload: {
    purchasedPolicyDetails: any;
  };
}

export interface ISetPaymentOption {
  type: ActionTypes.SetPaymentOption;
  payload: {
    paymentOption: PaymentOptions;
  };
}

/** One endorsement's availability, as returned by the eligibility endpoint. */
export interface IEndorsementEligibility {
  eligible: boolean;
  limits?: (string | number)[];
  retentions?: string[];
  reason?: string;
}

/** Eligibility keyed by application type ("BOP" | "GL"), then endorsement key. */
export type IEndorsementEligibilityMap = Record<string, Record<string, IEndorsementEligibility>>;

/** The user's endorsement choices, in the shape the API accepts. */
export type IEndorsementSelection = Record<string, any>;

export interface ISetEndorsementEligibility {
  type: ActionTypes.SetEndorsementEligibility;
  payload: {
    endorsementEligibility: IEndorsementEligibilityMap;
  };
}

export interface ISetEndorsementSelection {
  type: ActionTypes.SetEndorsementSelection;
  payload: {
    endorsementSelection: IEndorsementSelection;
  };
}

export interface ICoterieState {
  selectedQuote: IQuote;
  paymentOption: PaymentOptions | null;
  purchasedPolicyDetails: any;
  endorsementEligibility: IEndorsementEligibilityMap | null;
  endorsementSelection: IEndorsementSelection;
}

export enum PaymentOptions {
  Monthly = 'PAY_MONTHLY',
  Yearly = 'PAY_YEARLY',
}
